/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { jobsCreate } from "../../funcs/jobsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.PostApiLeadScraperMicroserviceApiV1JobsRequestBody$inboundSchema,
};

export const tool$jobsCreate: ToolDefinition<typeof args> = {
  name: "jobs_create",
  description: `Create a new job scraping task

This endpoint creates a new Google Maps scraping job`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await jobsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
